import { createSlice } from '@reduxjs/toolkit';
import { service } from '../shared/_services/api_service';
import { setLoading } from './loader';
import { errorHandler } from '../shared/_helper/responseHelper';

const initialState = {
  enquiryData: [],
  totalEnquiry: 0,
};

export const enquirySlice = createSlice({
  name: 'enquiry',
  initialState,
  reducers: {
    setEnquiryData(state, { payload }) {
      state.enquiryData = payload.result || [];
      state.totalEnquiry = payload.total || 0;
    },
  },
});

export const { setEnquiryData } = enquirySlice.actions;

export default enquirySlice.reducer;

export function getEnquiries(limit, offset, keyword, targetExam) {
  return async function getEnquiriesThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      await service.getEnquiries(limit, offset, keyword, targetExam).then(
        (response) => {
          dispatch(setLoading(false));
          dispatch(setEnquiryData(response.data));
        },
        (error) => {
          dispatch(setLoading(false));
          errorHandler(error.response);
        }
      );
    } catch (err) {
      dispatch(setLoading(false));
    }
  };
}
